import { ArrowRight } from "lucide-react";
import { categoryLabel } from "../data/tools";
import type { Locale, ToolDefinition } from "../types";

type ToolCardProps = {
  tool: ToolDefinition;
  locale: Locale;
};

export function ToolCard({ tool, locale }: ToolCardProps) {
  return (
    <a className="tool-card" href={tool.path}>
      <span className="tool-card__category">{categoryLabel(tool.category, locale)}</span>
      <strong>{tool.name}</strong>
      <span>{tool.tagline}</span>
      <span className="tool-card__arrow">
        <ArrowRight aria-hidden="true" size={18} />
      </span>
    </a>
  );
}
